module.exports = __webpack_public_path__ + "static/media/partners_list_mobile.1b46e87d.png";